import { Box, forwardRef, StyleProps } from '@chakra-ui/react';

import { XOutline } from '@bonusly/ds-icon';

interface AlertCloseProps extends StyleProps {
	onClick?: VoidFunction;
}

const AlertClose = forwardRef<AlertCloseProps, 'button'>(({ onClick, ...rest }, ref) => {
	return (
		<Box
			as="button"
			bg="transparent"
			borderRadius="full"
			color="blackAlpha.800"
			lineHeight={0}
			onClick={onClick}
			p={0.5}
			pos="absolute"
			ref={ref}
			right={3}
			top={3}
			transitionDuration="normal"
			transitionProperty="common"
			_hover={{
				bg: 'grayAlpha.200',
			}}
			{...rest}
		>
			<XOutline size="sm" />
		</Box>
	);
});

AlertClose.displayName = 'AlertClose';

export { AlertClose };
